import { render } from "./CardSummary.vue?vue&type=template&id=2005ab80&scoped=true"
import script from "./CardSummary.vue?vue&type=script&lang=js"
export * from "./CardSummary.vue?vue&type=script&lang=js"

import "./CardSummary.vue?vue&type=style&index=0&id=2005ab80&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2005ab80"]])

export default __exports__